"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftRailHeaderModule = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var GSWrapperComponent_1 = require("../../../../GSWrapperComponent");
var LeftRailHeader_1 = require("./LeftRailHeader");
function LeftRailHeaderModule(props) {
    return (React.createElement(GSWrapperComponent_1.GSWrapperComponent, null,
        React.createElement(LeftRailHeader_1.LeftRailHeader, { subscribeLink: props.subscribeLink })));
}
exports.LeftRailHeaderModule = LeftRailHeaderModule;
